import { createContext, useState, useMemo } from "react";
import { createTheme } from "@mui/material";

export const CustomThemesContext = createContext({});

const CustomThemesProvider = ({ children }) => {
  // *state that tracks dark/light mode of dynamic default theme
  const [themeMode, setThemeMode] = useState("light");

  // *non-dynamic custom themes
  const defaultDark = createTheme({
    palette: {
      mode: "dark",
      primary: {
        main: "#A2D2FF",
      },
    },
    typography: {
      fontFamily: "Martian Mono Variable",
    },
  });
  const busterLight = createTheme({
    palette: {
      mode: "light",
      background: { default: "#FFC8DD", paper: "#BDE0FE", object: "#665687" },
      // text: {
      //   primary: "#fff",
      // },
      primary: {
        main: "#A2D2FF",
      },
      secondary: {
        main: "#BDE0FE",
      },
    },
    typography: {
      fontFamily: "Martian Mono Variable",
    },
  });

  //*state to track current theme
  const [currentTheme, setCurrentTheme] = useState(busterLight);

  // *useMemo lets react dynamically switch theme (otherwise changing the theme state doesn't go "upstream" and adjust the themeProvider's theme prop in app.js, so the page doesn't update)
  const appliedTheme = useMemo(() => createTheme(currentTheme), [currentTheme]);

  return (
    <CustomThemesContext.Provider
      value={{
        themeMode,
        setThemeMode,
        busterLight,
        currentTheme,
        setCurrentTheme,
        appliedTheme,
        defaultDark,
      }}
    >
      {children}
    </CustomThemesContext.Provider>
  );
};
export default CustomThemesProvider;
